export enum RestartType {
  NOW = 'now',
  CUSTOM = 'on',
}

export interface RestartEndpointTaskSpecifics {
  restartTime: RestartType;
  restartOnDate?: string;
  restartOnHour?: number;
  restartOnMinute?: number;
}
